module.exports = __webpack_public_path__ + "static/media/create-main.04422209.svg";